// extracted by mini-css-extract-plugin
module.exports = {"floating":"styles_floating__33c_s","floatingHidden":"styles_floatingHidden__O4NF7"};